export default {
  'exception-500.exception.back': 'Voltar para Início',
  'exception-500.description.500': 'Desculpe, o servidor está reportando um erro',
};
